import { Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import { BLOCK_CLASSES } from '../blocks/constants';
import { findSelectedSection } from '@intercom/embercom-prosemirror-composer/lib/helpers/selection';
import { findChildren } from 'prosemirror-utils';
export const placeholderPluginKey = new PluginKey('placeholderPlugin');
export default class PlaceholderPlugin extends Plugin {
  constructor() {
    super({
      key: placeholderPluginKey,
      state: {
        init: () => ({
          showInserter: false,
          position: null
        }),
        apply(tr, value) {
          let newPluginState = tr.getMeta(this);
          if (newPluginState) {
            return newPluginState;
          }
          return value;
        }
      },
      props: {
        handleClickOn(view, clickPosition, _node, _nodePos, event, direct) {
          let plugin = this;
          let clickedElement = event.target;
          let {
            showInserter,
            position: previousPosition
          } = plugin.getState(view.state);
          let preventDefault = false;
          if (clickedElement.classList.contains(BLOCK_CLASSES.placeholder) && direct) {
            if (previousPosition === clickPosition) {
              showInserter = !showInserter;
            } else {
              showInserter = true;
            }
            plugin.forceSelection(view, clickPosition);
            preventDefault = true;
          } else {
            showInserter = false;
          }
          view.dispatch(view.state.tr.setMeta(this, {
            showInserter,
            position: clickPosition
          }));
          return preventDefault;
        }
      },
      appendTransaction(_tr, oldState, newState) {
        let plugin = this;
        let newTr = newState.tr;
        let selectedSection = findSelectedSection(newState);
        if (!selectedSection) {
          return null;
        }
        if (plugin.selectionIsLayout(newState)) {
          return null;
        }
        let sectionNode = selectedSection.node;
        let placeholders = findChildren(sectionNode, child => child.type === oldState.schema.nodes.placeholder);
        let nonPlaceholders = findChildren(sectionNode, child => child.type !== oldState.schema.nodes.placeholder);
        if (placeholders.length > 0 && nonPlaceholders.length > 0) {
          let placeholder = placeholders[0];
          let pos = placeholder.pos + selectedSection.start;
          newTr.delete(pos, pos + 1);
          return newTr;
        }
        return null;
      }
    });
  }

  /**
   * When there is a placeHolder and a text node in two different sections
   * Prosemirror always focus on the text node. This ensure that the placeholder is selected
   */
  forceSelection(view, clickPosition) {
    let tr = view.state.tr;
    tr.setSelection(TextSelection.create(tr.doc, clickPosition));
    view.dispatch(tr);
  }
  selectionIsLayout(state) {
    return state.selection.$from.nodeAfter?.attrs.type === 'table' && state.selection.$from.nodeAfter?.attrs.responsive;
  }
}